export default __webpack_public_path__ + "static/media/haze.36fa9899.png";